(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["podbase-poster-options"] && !Shopify.designMode) return;
  try {
    function initPosterOptions() {
    document.querySelectorAll('[data-podbase-poster-options]').forEach((root) => {
      if (root.dataset.posterReady) return;
      const price = root.querySelector('[data-poster-price]');
      let gallery = root.closest('[data-product-grid-content]')?.querySelector('media-gallery');
      const selector = root.querySelector('[data-poster-variant-id]');
      const submit = root.querySelector('[data-poster-submit]');
      const options = Array.from(selector.options);
      const sizes = Array.from(root.querySelectorAll('[data-poster-size]'));
      const finishes = Array.from(root.querySelectorAll('[data-poster-finish]'));
      if (!options.length) return;
      const galleryTemplate = document.createElement('template');
      let renderedGalleryValue;
      let renderedGalleryFinish;
      if (gallery && options.some((option) => option.dataset.gallery)) {
        gallery.setAttribute('data-oh-poster-gallery', '');
        galleryTemplate.innerHTML = gallery.outerHTML;
        const defaultOption = options.find((option) => option.defaultSelected);
        renderedGalleryValue = defaultOption?.value;
        renderedGalleryFinish = defaultOption?.dataset.finish;
        if (defaultOption?.dataset.gallery && gallery.querySelectorAll('slideshow-slide').length !== JSON.parse(defaultOption.dataset.gallery).length) {
          renderedGalleryValue = undefined;
          renderedGalleryFinish = undefined;
        }
      }
      function updatePosterImage(image, updatedImage) {
        if (!image || !updatedImage) return;
        ['width', 'height', 'alt', 'data_max_resolution'].forEach((name) => {
          const value = updatedImage.getAttribute(name);
          if (value !== null) image.setAttribute(name, value);
          else image.removeAttribute(name);
        });
        image.removeAttribute('srcset');
        const source = updatedImage.getAttribute('src');
        if (image.getAttribute('src') !== source) image.setAttribute('src', source);
      }
      function replacePosterGallery(option) {
        if (!option.dataset.gallery || !galleryTemplate.content.firstElementChild) return false;
        if (option.value === renderedGalleryValue) return true;
        if (option.dataset.finish === 'sans cadre' && renderedGalleryFinish === 'sans cadre') {
          renderedGalleryValue = option.value;
          return false;
        }
        const media = JSON.parse(option.dataset.gallery);
        const nextGallery = galleryTemplate.content.firstElementChild.cloneNode(true);
        nextGallery.setAttribute('data-oh-poster-gallery', '');
        const originalIds = [...new Set(Array.from(nextGallery.querySelectorAll('.product-media[data-media-id]'), (item) => item.dataset.mediaId))];
        if (!media.length || media.length > originalIds.length) return false;
        media.forEach((item, index) => {
          const ratio = item.width / item.height;
          nextGallery.querySelectorAll(`[data-media-id="${originalIds[index]}"]`).forEach((container) => {
            container.dataset.mediaId = item.id;
            container.style.setProperty('--ratio', ratio);
            const frame = container.closest('.product-media-container');
            if (frame) {
              frame.style.setProperty('--media-preview-ratio', ratio);
              frame.classList.remove('product-media-container--tallest');
            }
            const image = container.querySelector('img');
            if (!image) return;
            image.removeAttribute('srcset');
            image.src = container.closest('.dialog-zoomed-gallery') ? item.full : item.src;
            image.alt = item.alt;
            image.width = item.width;
            image.height = item.height;
            image.setAttribute('data_max_resolution', item.full);
          });
          ['.dialog-thumbnails-list__thumbnail', '.slideshow-controls__thumbnail'].forEach((selector) => {
            const button = nextGallery.querySelectorAll(selector)[index];
            if (!button) return;
            const image = document.createElement('img');
            image.src = item.thumb;
            image.alt = item.alt;
            image.width = item.width;
            image.height = item.height;
            image.loading = 'lazy';
            button.replaceChildren(image);
            button.setAttribute('aria-label', item.alt);
            button.setAttribute('aria-selected', String(index === 0));
            button.style.setProperty('--aspect-ratio', ratio);
            button.style.setProperty('--gallery-aspect-ratio', ratio);
          });
        });
        const tallest = media.reduce((best, item, index) => item.height / item.width > media[best].height / media[best].width ? index : best, 0);
        nextGallery.querySelectorAll('slideshow-slide')[tallest]?.classList.add('product-media-container--tallest');
        const currentMedia = Array.from(gallery.querySelectorAll('.product-media[data-media-id]'));
        const updatedMedia = Array.from(nextGallery.querySelectorAll('.product-media[data-media-id]'));
        if (currentMedia.length !== updatedMedia.length) return false;
        currentMedia.forEach((container, index) => {
          const updated = updatedMedia[index];
          container.dataset.mediaId = updated.dataset.mediaId;
          container.style.setProperty('--ratio', updated.style.getPropertyValue('--ratio'));
          const frame = container.closest('.product-media-container');
          const updatedFrame = updated.closest('.product-media-container');
          if (frame && updatedFrame) {
            frame.style.setProperty('--media-preview-ratio', updatedFrame.style.getPropertyValue('--media-preview-ratio'));
            frame.classList.toggle('product-media-container--tallest', updatedFrame.classList.contains('product-media-container--tallest'));
          }
          const image = container.querySelector('img');
          const updatedImage = updated.querySelector('img');
          updatePosterImage(image, updatedImage);
        });
        ['.dialog-thumbnails-list__thumbnail', '.slideshow-controls__thumbnail'].forEach((selector) => {
          const updatedButtons = nextGallery.querySelectorAll(selector);
          gallery.querySelectorAll(selector).forEach((button, index) => {
            const updated = updatedButtons[index];
            if (!updated) return;
            updatePosterImage(button.querySelector('img'), updated.querySelector('img'));
            ['aria-label', 'aria-selected', 'style'].forEach((name) => {
              const value = updated.getAttribute(name);
              if (value !== null) button.setAttribute(name, value);
            });
          });
        });
        if (media.length !== originalIds.length || gallery.hasAttribute('data-oh-variable-media-count')) {
          gallery.setAttribute('data-oh-variable-media-count', '');
          ['slideshow-slide', '.media-gallery__grid > li', '.dialog-zoomed-gallery > li', '.dialog-thumbnails-list__thumbnail', '.slideshow-controls__thumbnail', '.slideshow-controls__dots > li'].forEach((selector) => {
            gallery.querySelectorAll(selector).forEach((element, index) => {
              element.hidden = index >= media.length;
            });
          });
          gallery.querySelectorAll('.slideshow-controls__counter').forEach((counter) => {
            if (counter.lastChild?.nodeType === Node.TEXT_NODE) counter.lastChild.textContent = String(media.length);
          });
        }
        gallery.slideshow?.select(0, undefined, { animate: false });
        renderedGalleryValue = option.value;
        renderedGalleryFinish = option.dataset.finish;
        return true;
      }
      function selectImage(option) {
        const imageNote = root.querySelector('[data-poster-image-note]');
        if (imageNote) imageNote.hidden = option.dataset.imageMissing !== 'true';
        if (!gallery || !option.dataset.image) return;
        if (replacePosterGallery(option)) return;
        gallery.querySelectorAll(`[data-media-id="${root.dataset.primaryMediaId}"] img`).forEach((image) => {
          image.removeAttribute('srcset');
          image.src = image.closest('.dialog-zoomed-gallery') ? option.dataset.imageFull : option.dataset.image;
          image.alt = option.dataset.imageAlt;
          image.dataset.maxResolution = option.dataset.imageFull;
          if (option.dataset.gallery) image.setAttribute('data_max_resolution', option.dataset.imageFull);
        });
        gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail:first-child img, .slideshow-controls__thumbnail:first-child img').forEach((image) => {
          image.removeAttribute('srcset');
          image.src = option.dataset.imageThumb;
          image.alt = option.dataset.imageAlt;
        });
        gallery.slideshow?.select(0, undefined, { animate: false });
      }
      function applySelection(size, finish, updateUrl = true) {
        const candidates = options.filter((option) => option.dataset.size === size);
        const option = candidates.find((item) => item.dataset.finish === finish && !item.disabled)
          || candidates.find((item) => item.dataset.finish === 'sans cadre' && !item.disabled)
          || candidates.find((item) => !item.disabled)
          || candidates.find((item) => item.dataset.finish === finish)
          || candidates[0];
        if (!option) { submit.disabled = true; return; }
        selector.value = option.value;
        sizes.forEach((radio) => {
          radio.checked = radio.value === option.dataset.size;
          radio.disabled = !options.some((item) => item.dataset.size === radio.value && !item.disabled);
        });
        finishes.forEach((radio) => {
          const matching = candidates.find((item) => item.dataset.finish === radio.value);
          radio.checked = radio.value === option.dataset.finish;
          radio.disabled = !matching || matching.disabled;
          radio.closest('[data-poster-finish-label]').hidden = !matching;
        });
        price.textContent = option.dataset.price;
        submit.disabled = option.disabled;
        submit.textContent = option.disabled ? root.dataset.soldOut : root.dataset.addLabel;
        selectImage(option);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('poster_variant', option.value);
          window.history.replaceState(null, '', url);
        }
      }
      const requested = new URLSearchParams(window.location.search).get('poster_variant');
      const initial = options.find((option) => option.value === requested && !option.disabled)
        || options.find((option) => option.selected && !option.disabled)
        || options.find((option) => !option.disabled) || options[0];
      sizes.forEach((radio) => radio.addEventListener('change', () => {
        if (radio.checked) applySelection(radio.value, finishes.find((item) => item.checked)?.value);
      }));
      finishes.forEach((radio) => radio.addEventListener('change', () => {
        if (radio.checked) applySelection(sizes.find((item) => item.checked)?.value, radio.value);
      }));
      selector.addEventListener('change', () => {
        const option = selector.selectedOptions[0];
        if (option) applySelection(option.dataset.size, option.dataset.finish);
      });
      root.querySelector('[data-poster-form]').addEventListener('submit', (event) => {
        if (!selector.selectedOptions[0] || selector.selectedOptions[0].disabled) event.preventDefault();
      });
      root.dataset.posterReady = 'true';
      applySelection(initial.dataset.size, initial.dataset.finish, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPosterOptions);
  else initPosterOptions();
  document.addEventListener('shopify:section:load', initPosterOptions);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["podbase-poster-prototype"] && !Shopify.designMode) return;
  try {
    function initPosterPrototype() {
    document.querySelectorAll('[data-podbase-poster-prototype]').forEach((root) => {
      if (root.dataset.posterReady) return;
      root.dataset.posterReady = 'true';
      const price = root.querySelector('[data-poster-price]');
      const gallery = root.closest('[data-product-grid-content]')?.querySelector('media-gallery');
      const id = root.querySelector('[data-poster-variant-id]');
      const submit = root.querySelector('[data-poster-submit]');
      function selectImage(radio) {
        if (!gallery) return;
        gallery.querySelectorAll(`[data-media-id="${root.dataset.primaryMediaId}"] img`).forEach((image) => {
          image.removeAttribute('srcset');
          image.src = image.closest('.dialog-zoomed-gallery') ? radio.dataset.imageFull : radio.dataset.image;
          image.alt = radio.dataset.imageAlt;
          image.dataset.maxResolution = radio.dataset.imageFull;
        });
        gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail:first-child img, .slideshow-controls__thumbnail:first-child img').forEach((image) => {
          image.removeAttribute('srcset');
          image.src = radio.dataset.imageThumb;
          image.alt = radio.dataset.imageAlt;
        });
      }
      const initial = root.querySelector('input[type=radio][data-price]:checked');
      if (initial) selectImage(initial);
      root.querySelectorAll('input[type=radio][data-price]').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked || radio.disabled) return;
          id.value = radio.value;
          price.textContent = radio.dataset.price;
          selectImage(radio);
          submit.disabled = false;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPosterPrototype);
  } else {
    initPosterPrototype();
  }
  } catch(e) { console.error(e); }
})();

})();
